import React from 'react';
import styled from 'styled-components';
import { Alert } from '@amzn/storm-ui';
import { useTranslation } from 'react-i18next';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  padding: 2rem;
  padding-top: 4rem;
  text-align: left;
  width: 100%;
`;

const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.color.gray[600]};
  margin: 0;
`;

const BackLink = styled.a`
  color: ${({ theme }) => theme.color.blue[600]};
  text-decoration: none;
  margin-top: 1rem;

  &:hover {
    text-decoration: underline;
  }
`;

export function RouteErrorElement(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <ErrorContainer>
      <Alert variant="error" header={t('route-error-element-header')}>
        <ErrorMessage>{t('route-error-element-message')}</ErrorMessage>
        <BackLink href="/">{t('route-error-element-button')}</BackLink>
      </Alert>
    </ErrorContainer>
  );
}
